import { render, staticRenderFns } from "./AirwayMenu.vue?vue&type=template&id=02dc0e26&scoped=true&"
import script from "./AirwayMenu.vue?vue&type=script&lang=js&"
export * from "./AirwayMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dc0e26",
  null
  
)

export default component.exports